import styles from "./styles.module.scss";
import img2 from "../../images/2.png";
import Section from "../../components/Section";
import coral_draw_icon from "../../graphics/coral_draw_icon.svg";

import vector1 from "../../images/vector_1.png";
import vector2 from "../../images/vector_2.png";
import vector3 from "../../images/vector_3.png";
import vector4 from "../../images/vector_4.png";

const Vectors = () => {
  return (
    <Section color="#1D1D1D">
      <div className={styles.container}>
        <div className={styles.title}>
          <div>
            <img src={img2} alt="2" />
          </div>
          <h1>ВЕКТОРНАЯ ГРАФИКА</h1>
        </div>

        <div className={styles.content}>
          <div className={styles.task}>
            <h4 className={styles.sub_title}>Задача</h4>
            <p className={styles.text}>
              Необходимо было создать иллюстрации для агентства, которое
              специализируется на кепминге.
            </p>
          </div>

          <div className={styles.execution}>
            <h4 className={styles.sub_title}>Реализация</h4>
            <div className={styles.icon_text}>
              <div>
                <img src={coral_draw_icon} alt="Coral draw" />
              </div>
              <p>CorelDRAW</p>
            </div>
          </div>
        </div>

        <div className={styles.images}>
          <div>
            <img src={vector1} alt="" />
          </div>
          <div>
            <img src={vector2} alt="" />
          </div>
          <div>
            <img src={vector3} alt="" />
          </div>
          <div>
            <img src={vector4} alt="" />
          </div>
        </div>
      </div>
    </Section>
  );
};

export default Vectors;
